import { api } from "aldoo-ra/API"

const statusApi = api("status")

// Projects
export const createProject = (payload) => statusApi({ create_project: payload })
export const listProjects = (orgId) => statusApi({ list_projects: orgId ? { orgId } : {} })
export const getProject = (projectId) => statusApi({ get_project: { projectId } })
export const updateProject = (payload) => statusApi({ update_project: payload })
export const deleteProject = (projectId) => statusApi({ delete_project: { projectId } })
export const setProjectPublic = (payload) => statusApi({ set_project_public: payload })

// Members
export const addMember = (payload) => statusApi({ add_member: payload })
export const removeMember = (projectId, userId) => statusApi({ remove_member: { projectId, userId } })
export const listMembers = (projectId) => statusApi({ list_members: { projectId } })
export const listOrgMembersForProject = (projectId, includeExisting = false) =>
  statusApi({ list_org_members_for_project: { projectId, includeExisting } })

// Components (group)
export const createComponent = (payload) => statusApi({ create_component: payload })
export const listComponents = (projectId, opts = {}) => {
  const normalized = typeof opts === "string" ? { environment: opts } : opts
  const { environment, withStats, days, from, to, granularity, tzOffsetMinutes } = normalized
  const payload = { projectId }
  if (environment) payload.environment = environment
  if (withStats) payload.withStats = true
  if (days) payload.days = days
  if (from) payload.from = from
  if (to) payload.to = to
  if (granularity) payload.granularity = granularity
  if (tzOffsetMinutes != null) payload.tzOffsetMinutes = tzOffsetMinutes
  return statusApi({ list_components: payload })
}
export const updateComponent = (componentId, updates) =>
  statusApi({ update_component: { componentId, updates } })
export const deleteComponent = (componentId) => statusApi({ delete_component: { componentId } })
export const pauseComponent = (componentId, pausedUntil, resume) =>
  statusApi({ pause_component: { componentId, pausedUntil, resume } })

// Checks (url + action inside a component)
export const createCheck = (payload) => statusApi({ create_check: payload })
export const listChecks = ({ componentId, projectId }) =>
  statusApi({ list_checks: componentId ? { componentId } : { projectId } })
export const updateCheck = (checkId, updates) =>
  statusApi({ update_check: { checkId, updates } })
export const deleteCheck = (checkId) => statusApi({ delete_check: { checkId } })
export const pauseCheck = (checkId, pausedUntil, resume) =>
  statusApi({ pause_check: { checkId, pausedUntil, resume } })
export const testCheckNow = (checkId) => statusApi({ test_check_now: { checkId } })
export const testCheckPayload = (payload) => statusApi({ test_check_payload: { payload } })
export const captureReference = (checkId) => statusApi({ capture_reference: { checkId } })
export const markAsReference = (checkId, snapshotId) =>
  statusApi({ mark_as_reference: { checkId, snapshotId } })
export const listSnapshots = (checkId, limit = 20) =>
  statusApi({ list_snapshots: { checkId, limit } })

// KPI reads
export const readComponentUptime = (componentId) => statusApi({ read_component_uptime: { componentId } })
export const readComponentLatency = (componentId) => statusApi({ read_component_latency: { componentId } })
export const readComponentHistory = (componentId, daysOrOpts = 90) =>
  (typeof daysOrOpts === "object"
    ? statusApi({ read_component_history: { componentId, ...daysOrOpts } })
    : _readComponentHistoryByDays(componentId, daysOrOpts))

const _readComponentHistoryByDays = (componentId, days = 90) =>
  statusApi({ read_component_history: { componentId, days } })

// Notification channels (named targets per org)
export const listNotificationChannels = (orgId, kind) =>
  statusApi({ list_notification_channels: kind ? { orgId, kind } : { orgId } })
export const upsertNotificationChannel = (payload) =>
  statusApi({ upsert_notification_channel: payload })
export const deleteNotificationChannel = (channelId) =>
  statusApi({ delete_notification_channel: { channelId } })

// Notification rules
export const listNotificationRules = (orgId) =>
  statusApi({ list_notification_rules: { orgId } })
export const upsertNotificationRule = (payload) =>
  statusApi({ upsert_notification_rule: payload })
export const deleteNotificationRule = (ruleId) =>
  statusApi({ delete_notification_rule: { ruleId } })
export const testNotificationRule = (ruleId) =>
  statusApi({ test_notification_rule: { ruleId } })

// Notification events (incidents fired by rules)
export const listNotificationEvents = (params) =>
  statusApi({ list_notification_events: params })
export const notificationEventsStats = (params) =>
  statusApi({ notification_events_stats: params })
export const resolveNotificationEvents = (params) =>
  statusApi({ resolve_notification_events: params })
export const deleteNotificationEvents = (params) =>
  statusApi({ delete_notification_events: params })

// Incidents
export const listIncidents = (projectId, componentId, status) =>
  statusApi({ list_incidents: { projectId, componentId, status } })
export const getIncident = (incidentId) => statusApi({ get_incident: { incidentId } })
export const addIncidentNote = (incidentId, text, action, dayKey) =>
  statusApi({ add_incident_note: { incidentId, text, action, dayKey } })
export const manualOpenIncident = (componentId, reason, severity, dayKey) =>
  statusApi({ manual_open_incident: { componentId, reason, severity, dayKey } })
export const manualCloseIncident = (incidentId) =>
  statusApi({ manual_close_incident: { incidentId } })

// Public
export const getPublicStatus = (slug, days = 90) =>
  statusApi({ get_public_status: { slug, days } })

// API keys
export const listProjectKeys = (projectId) => statusApi({ list_project_keys: { projectId } })
export const attachKeyToProject = (apiKeyId, projectId, label) =>
  statusApi({ attach_key_to_project: { apiKeyId, projectId, label } })
export const detachKeyFromProject = (apiKeyId) =>
  statusApi({ detach_key_from_project: { apiKeyId } })

// Subscriptions
export const createSubscription = (payload) => statusApi({ create_subscription: payload })
export const listSubscriptions = (projectId) => statusApi({ list_subscriptions: { projectId } })
export const updateSubscription = (payload) => statusApi({ update_subscription: payload })
export const deleteSubscription = (subscriptionId) =>
  statusApi({ delete_subscription: { subscriptionId } })
